import i18n from "src/i18n/config";
import { z } from "zod";

export const projectValidationSchema = z
    .object({
        action: z.enum(["add", "remove", "extend"]),
        name: z
            .string()
            .regex(/^[a-zA-Z0-9_/-]+$/, i18n.t("modals:productProject.input.name.validation.cannotContainSpecialCharacters")),
        path: z.string().optional(),
        remote: z.string().nullable().optional(),
        revision: z.string().nullable().optional(),
    })
    .refine(
        (data) => {
            if (data.action === "add") {
                return data.path && data.path.length > 0;
            }
            return true;
        },
        {
            message: i18n.t("modals:productProject.input.path.validation.requiredWhenAdding"),
            path: ["path"],
        },
    );
export const actionOptions = [
    { value: "add", label: "Add new project" },
    { value: "remove", label: "Remove existing project" },
];
